import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { ILicenceProfile } from "../../api/ILicenceProfile";
import {
  GetRequestsForInformationFromLicenseeReturnFetchUrl,
  IRequestForInformation,
} from "../../api/RequestForInformation";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { RequestsForInformationGridProps } from "./RequestsForInformationGridProps";

const GetUrlForRequestForInformation = (
  licenceProfile: ILicenceProfile,
  requestForInformation: IRequestForInformation
) => {
  return `/licence-profile/${licenceProfile.profileNo}/compliance/request-for-information/${requestForInformation.rfiid}`;
};

const RequestsForInformationGrid = ({
  licenceProfile,
  licenseeReturnId,
}: RequestsForInformationGridProps) => {
  const getFetchUrlFn = (returnId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetRequestsForInformationFromLicenseeReturnFetchUrl(
        returnId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };
    return fetchUrlFn;
  };

  const fetchUrlFn = getFetchUrlFn(licenseeReturnId);

  const tableColumnsBig: Column<Record<string, IRequestForInformation>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Licensee Return")}</span>
            </td>
            <td>
              <Link
                to={GetUrlForRequestForInformation(
                  licenceProfile,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date Issued by EPA",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
    {
      Header: "Licensee Response Date",
      accessor: "responsereceiveddate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
  ];

  const tableColumnsSmall: Column<Record<string, IRequestForInformation>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Licensee Return")}</span>
            </td>
            <td>
              <Link
                to={GetUrlForRequestForInformation(
                  licenceProfile,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrlFn}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrlFn}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { RequestsForInformationGrid };
